import { Transition } from "components/shared/column";
import { paths } from "helpers/paths";
import React from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import Chat from "./chat";
import List from "./list";

export default function CarChats(props) {
    const location = useLocation();
    const history = useHistory();
    const closeChat = () => history.push(paths.carChats);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route
                    path={paths.carChatsShow(":id")}
                    render={(rest) => {
                        const chatProps = { baseUrl: paths.carChats, back: closeChat, chatId: rest.match.params.id };
                        return (
                            <Transition dir="full">
                                <Chat {...chatProps} />
                            </Transition>
                        );
                    }}
                />
                <Route
                    exact
                    path={paths.carChats}
                    render={() => <List {...props} title="Чаты по грузовикам" withoutPageSize />}
                />
            </Switch>
        </div>
    );
}
